import React from "react";

export const SessionFlowContext = React.createContext(null);